import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../CoursePage.css";
import WatermarkOverlay from "../components/WatermarkOverlay";
import "../Watermark.css";


function CoursePage() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [images, setImages] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const hasFetched = useRef(false);

  const API_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    if (hasFetched.current) return;
    hasFetched.current = true;

    async function fetchCourseImages() {
      try {
        const response = await fetch(`${API_URL}/api/course/${courseId}/images`);
        if (!response.ok) throw new Error("Failed to fetch course images");

        const data = await response.json();
        setImages(data.images || []);
        setCourseName(data.courseName || "");
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchCourseImages();
  }, [courseId, navigate, user, API_URL]);

  useEffect(() => {
    // Disable Ctrl+P / ⌘+P
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "p" || e.key === "P")) {
        e.preventDefault();
        alert("Printing is disabled on this page.");
      }
    };

    // Disable right-click globally
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable text/image selection and copy
    const handleSelectStart = (e) => e.preventDefault();
    const handleCopy = (e) => e.preventDefault();

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("selectstart", handleSelectStart);
    document.addEventListener("copy", handleCopy);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("selectstart", handleSelectStart);
      document.removeEventListener("copy", handleCopy);
    };
  }, []);

  if (loading) return <p>Loading course images...</p>;
  if (error) return <p>Error: {error}</p>;
  if (images.length === 0) return <p>No images found for this course.</p>;

  return (
    <div className="course-page-container no-print">
          <WatermarkOverlay user={user} />
      <h1 className="course-title">{courseName}</h1>
      <div className="image-grid">
        {images.map((url, index) => (
          <div key={index} className="image-wrapper">
            <img
              src={url}
              alt={`Page ${index + 1}`}
              className="course-image"
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
              onMouseDown={(e) => e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable="false"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default CoursePage;
